import { render, staticRenderFns } from "./Uses.vue?vue&type=template&id=3d89d944&scoped=true&"
import script from "./Uses.vue?vue&type=script&lang=js&"
export * from "./Uses.vue?vue&type=script&lang=js&"
import style0 from "./Uses.vue?vue&type=style&index=0&id=3d89d944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89d944",
  null
  
)

export default component.exports